import {z} from 'zod'

export const LoginFormSchema = z.object({
    email: z.string().min(1, {message: 'errors:email'}).email({message: 'errors:email_valid'}),
    password: z.string().min(8, {message: 'errors:password'})
})
export type LoginValidationSchema = z.infer<typeof LoginFormSchema>
